(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/text-list.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/text-list.js');
"use strict";

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const TextList = _ref => {
  let textOptions = _ref.textOptions;
  return React.createElement(React.Fragment, null, textOptions && Array.isArray(textOptions) && textOptions.map((_ref2, index) => {
    let content = _ref2.content,
      classes = _ref2.classes;
    if (typeof content === 'string') {
      let itemClasses;
      if (Array.isArray(classes) && classes.length > 0 && !_.find(classes, item => typeof item !== 'string')) {
        itemClasses = classes.toString().replace(/,/g, ' ');
      } else if (typeof classes === 'string') {
        itemClasses = classes;
      }
      return React.createElement("p", {
        className: "payfooter-text ".concat(itemClasses ? itemClasses : '').trim(),
        key: "".concat(content, "_").concat(index)
      }, content);
    }
    const className = content.props.className && "".concat(content.props.className, " payfooter-text") || 'payfooter-text';
    return React.createElement(content.type, _extends({
      key: "".concat(content.props.children, "_").concat(index)
    }, content.props, {
      className: className
    }), content.props.children);
  }));
};
svs.tur.ReactPayfooter.TextList = TextList;

 })(window);